import { AxiosResponse } from "axios";
import { CartTotal } from "common/features/cart/cartModels";
import { manageItemTotalsApi } from "common/features/order/orderAPI";
import { ItemTotalsPayloadInteface, ItemTotalsResponseInteface, OrderTotal } from "common/features/order/orderModels";
import { toast } from "react-toastify";
import { decryptJson, handleDecrypt } from "common/utils/react-ec-utils";


export const manageItemTotalsHelper = async (payload: ItemTotalsPayloadInteface) => {
    let totalsData: ItemTotalsResponseInteface|any = null;
    try {
      const response: AxiosResponse = await manageItemTotalsApi(payload);

      if (response.status == 200) {
        const data = decryptJson(response.data.encryptedText)
        totalsData = data as ItemTotalsResponseInteface;
      } else {
        errorNotify('Unable to process');
      }
    } catch (error) {}
    if (payload?.sagaCallBack != null && typeof payload?.sagaCallBack === 'function') {
      payload.sagaCallBack();
    }
    return totalsData;
  };

  export const successNotify = (message: string) =>
  toast.success(message, {
    position: toast.POSITION.TOP_CENTER,
  });

  export const errorNotify = (message: string) =>
  toast.error(message, {
    position: toast.POSITION.TOP_CENTER,
  });


  export const getTotalByTitle = (totals: any, title: string) => {
    let filteredData = totals?.filter((total: any) => total.title == title);
    if (filteredData.length > 0) {
      return filteredData[0].value;
    } else {
      return 0;
    }
  };

  export const getTotalByCode = (
    totals: CartTotal[] | OrderTotal[],
    code: string,
  ): CartTotal | OrderTotal | null => {
    let totalIndex = totals?.findIndex((total) => Number(+total.code) == Number(+code));
    if (totalIndex >= 0) {
      return totals[totalIndex];
    } else {
      return null;
    }
  };

  export const getTitleByCode = (
    totals: CartTotal[] | OrderTotal[],
    code: string,
  ): CartTotal | OrderTotal | null => {
    let totalIndex = totals?.findIndex((total) => Number(+total.code) == Number(+code));
    if (totalIndex >= 0) {
      return totals[totalIndex];
    } else {
      return null;
    }
  };